<script>
import {onMount} from 'svelte';
  import { Card, Button } from "../../components/ui";
  import { Image, Modal } from "../../components/display";
  import { currentProduct } from "../../stores/product.js";
  import { productEdit } from "../../helper/PostHelper";
  import { getProductData } from "../../helper/GetHelper";
  import { getFeatureGroups } from "../../helper/PostHelper";
import SortableListCardEdit from "../../edit/SortableListCard_Edit.svelte";

  import ProductEdit from "../../edit/Product_Edit.svelte";
  export let currentRoute;
    const productId = currentRoute.namedParams.id; //productId

  let editMode = false;
  let model = null;
  let featureGroups = null
  const edit = async function() {
    model = await getProductData();
    editMode = true;
  };

onMount(async()=>{
  featureGroups = await getFeatureGroups(productId);
})
  const save = async function() {
    productEdit(model);
    editMode = false;
  };

  const addNewFeatureGroup = function(){
      let newItem = {
            name: `My ${featureGroups.length + 1}. Feature`, 
            value: featureGroups.length,
            sortPos: featureGroups.length, 
            editMode: true, 
            image: null,
            description: `Describe the main characteristics of your product in order of importance.`,
            items:[
                {text: null, sortPos: 0, value: 0},
                {text: null, sortPos: 1, value: 1},
                {text: null, sortPos: 2, value: 2},
                {text: null, sortPos: 3, value: 3},
                {text: null, sortPos: 4, value: 4}
            ]
        }
	    featureGroups = [...featureGroups, newItem];
  }
</script>
<div class="block">
{#if $currentProduct != null}
  <Card class="w-1/2 float-left">
    <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
      <div class="flex flex-row">
        <div class="flex-grow">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            {$currentProduct.name}
          </h3>
          <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
            Product Details
          </p>
        </div>
        <Image
          src={$currentProduct.logo}
          class="-ml-1 inline-block h-6 w-6 rounded-full text-white shadow-solid" />
        <Button on:submit={edit}>Edit</Button>
      </div>

    </div>

    <div>
      <dl>
        <div
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dd class="text-sm leading-5 font-medium text-gray-500">Type</dd>
          <dt
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {$currentProduct.type}
          </dt>
        </div>
        <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dd class="text-sm leading-5 font-medium text-gray-500">
            Target Group
          </dd>
          <dt
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {$currentProduct.targetGroup}
          </dt>
        </div>
        <div
          class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dd class="text-sm leading-5 font-medium text-gray-500">Image URL</dd>
          <dt
            class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
            {$currentProduct.file}
          </dt>
        </div>
      </dl>
    </div>
  </Card>
{/if}
</div>
<div class="block">
{#if featureGroups != null}

   {#each featureGroups as featureGroup, i}
    <div class="w-1/3 float-left">
        <SortableListCardEdit bind:model={featureGroup} hasFileSelect={true} class="p-4" hasEditMode={true}/>
    </div>
    {/each}
    <div class="w-1/3 float-left opacity-50 hover:opacity-100 cursor-pointer" style="height:410px">
        <Card class="p-4 h-full text-center">
            <button type="button" on:click={addNewFeatureGroup} style="margin-top:157px">
                +
            </button>
        </Card>    
    </div>
  <!-- <div class="my-6 p-4">
    <h2 class="text-2xl">Features</h2>
    <ul>
      {#each staticData.buyerPersona.pjg.gains.items as gain}
          <li class="flex flex-row">
        <Input class="w-1/6"  bind:model={gain.text} />
        <Button on:submit={()=>{pjgSave(productId, personaId,gain)}}>Save gain</Button>
        </li>
      {/each}
         <li class="flex flex-row">
          <Input class="w-1/6" bind:model={newGain} />
          <Button on:submit={()=>{pjgNew('gains', newGain)}}>Add new gain</Button>
        </li>
    </ul>
  </div> -->
{/if}
</div>

{#if editMode}
  <Modal style="max-width:42em">
    <div class="p-4">
      <ProductEdit bind:model />
      <Button primary={true} on:submit={save}>Save</Button>
      <Button
        on:submit={() => {
          editMode = false;
        }}>
        Cancel
      </Button>
    </div>

  </Modal>
{/if}
